import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize | undefined;
  /** Accessible label. Pass `null` inside a control that already announces its busy state. */
  label?: string | null | undefined;
  className?: string | undefined;
}

export function Spinner({ size = 'md', label = 'Carregando…', className }: SpinnerProps) {
  return (
    <span
      className={[styles.spinner, styles[size], className].filter(Boolean).join(' ')}
      role={label === null ? 'presentation' : 'status'}
      aria-live={label === null ? undefined : 'polite'}
      aria-hidden={label === null ? true : undefined}
    >
      {label !== null ? <span className="visually-hidden">{label}</span> : null}
    </span>
  );
}
